import React, { Component } from "react";
import { Modal, Button, Form, Alert, InputGroup } from "react-bootstrap";
import axios from 'axios';
import "react-datepicker/dist/react-datepicker.css";
import { validateChangePasswordForm } from './../utils/validation';
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import CommonToast from "./Toaster/CommonToast";

export default class NewPasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      newPasswordCheck: "",
      showAlert: false,
      completed: false,
      hasError: false,
      errors: {},
      errMsg: "",
      showOldPassword: false,
      showNewPassword: false,
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };

    if (name === "oldPassword" && value.length >= 6) delete errors.oldPassword;
    if (name === "newPassword" && value.length >= 6) delete errors.newPassword;

    this.setState({ [name]: value, errors });
  };

  togglePasswordVisibility = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field],
    }));
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({
      completed: true,
      showToast: true,
      toastMessage: "Password changed successfully!",
      toastVariant: "success",
      oldPassword: "",
      newPassword: "",
      color: 'green',
      newPasswordCheck: "",
      errors: {},
      showOldPassword: false,
      showNewPassword: false,
    });
    const { oldPassword, newPassword, newPasswordCheck } = this.state;
    const errors = validateChangePasswordForm(oldPassword, newPassword, newPasswordCheck);

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    if (newPassword !== newPasswordCheck) {
      this.setState({
        showAlert: true,
        errors: { ...errors, newPasswordCheck: "Passwords do not match" },
      });
      return;
    }

    const userId = JSON.parse(localStorage.getItem('user'))?.id;
    const data = { oldPassword, newPassword };

    axios.put(`users/changePassword/${userId}`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(() => {
        this.setState({
          completed: true,
          showToast: true,
          toastMessage: "Password changed successfully!",
          toastVariant: "success",
          oldPassword: "",
          newPassword: "",
          newPasswordCheck: "",
          errors: {},
          showOldPassword: false,
          showNewPassword: false,
        });
        setTimeout(() => {
          this.setState({ showToast: false })
          this.props.onHide();
        }, 1500);
      })
      .catch(err => {
        this.setState({
          hasError: true,
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
          errMsg: err.response?.data?.message || "Something went wrong",
        });

        setTimeout(() => {
          this.setState({ showToast: false });
        }, 900);
      });
  };

  render() {
    const {
      showAlert, completed, hasError, errMsg,
      oldPassword, newPassword, newPasswordCheck,
      errors, showOldPassword, showNewPassword
    } = this.state;

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <Modal {...this.props} size="md" centered>
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">🔐 Change Password</Modal.Title>
          </Modal.Header>

          <Modal.Body className="px-4 py-3">
            {/* {showAlert && (
              <Alert variant="warning" className="text-center">
                Passwords do not match.
              </Alert>
            )}

            {hasError && (
              <Alert variant="danger" className="text-center">
                {errMsg}
              </Alert>
            )} */}

            <Form onSubmit={this.onSubmit}>
              <Form.Group controlId="formOldPassword" className="mb-4">
                <Form.Label className="fw-semibold">Old Password <span className="text-danger">*</span></Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showOldPassword ? "text" : "password"}
                    name="oldPassword"
                    placeholder="Enter old password"
                    value={oldPassword}
                    onChange={this.handleChange}
                    isInvalid={!!errors.oldPassword}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() => this.togglePasswordVisibility("showOldPassword")}
                    tabIndex={-1}
                  >
                    {showOldPassword ? <EyeSlashFill /> : <EyeFill />}
                  </Button>
                  <Form.Control.Feedback type="invalid">
                    {errors.oldPassword}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group controlId="formNewPassword" className="mb-4">
                <Form.Label className="fw-semibold">New Password <span className="text-danger">*</span></Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showNewPassword ? "text" : "password"}
                    name="newPassword"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={this.handleChange}
                    isInvalid={!!errors.newPassword}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() => this.togglePasswordVisibility("showNewPassword")}
                    tabIndex={-1}
                  >
                    {showNewPassword ? <EyeSlashFill /> : <EyeFill />}
                  </Button>
                  <Form.Control.Feedback type="invalid">
                    {errors.newPassword}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group controlId="formNewPasswordCheck" className="mb-4">
                <Form.Label className="fw-semibold">Confirm Password <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="password"
                  name="newPasswordCheck"
                  placeholder="Repeat new password"
                  value={newPasswordCheck}
                  onChange={this.handleChange}
                  isInvalid={!!errors.newPasswordCheck}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.newPasswordCheck}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-flex justify-content-end pt-3">
                <Button variant="outline-primary" type="submit">
                  Update Password
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
